// extracted by mini-css-extract-plugin
module.exports = {"containerSwitcher":"LanguageSwitcherContainer_containerSwitcher__1Mer4","boxExternalWithoutLogin":"LanguageSwitcherContainer_boxExternalWithoutLogin__BP4np"};